var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"games-block container-mobile"},[_c('div',{staticClass:"games-block-body"},[_c('redirectButton',{staticClass:"games-block-puzzle",attrs:{"pathname":"puzzles","html":_vm.$t('header.puzzleLogo')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }